import { getLocalDateFullMonthText } from "@merchstores/admin/components/DateTime";
import { ACTIVE_ORDER_ID, ICombinedOrder, OrderStatus } from "@merchstores/admin/components/MerchStoreOrders";
import { Role } from "@merchstores/admin/context/Roles";
import { IMerchStore } from "@merchstores/admin/components/MerchStore";

import "./OrderDetailsSummary.scss";
import OrderCalculator from "@merchstores/admin/components/MerchStoreOrders/OrderCalculator";
import { moneyFormat } from "@merchstores/shared/components/Money";
import { OrderCheckoutCTA } from "./OrderCheckoutCTA";

export interface IOrderDetailsSummaryProps {
  merchStore: IMerchStore;
  combinedOrder: ICombinedOrder;
  userRole: Role;
  closeDate: string;
}

export const OrderDetailsSummary: React.FC<IOrderDetailsSummaryProps> = (props: IOrderDetailsSummaryProps) => {
  const merchStore = props.merchStore;
  const closeDate = props.closeDate;
  const order = props.combinedOrder;
  const isClosed = order.status === OrderStatus.closed;
  const orderTotal = OrderCalculator.calculateSummaryTotal(order);

  const isActiveOrder = order.id === ACTIVE_ORDER_ID;

  return (
    <div className="order-details-sidebar-menu p-8 bg-gray-50 lg:min-w-order-sidebar flex flex-col items-start rounded-tr-24 rounded-br-24">
      <div className="w-full">
        <div className="w-full text-sm text-merch-dark-gray font-bold mb-5">
          <div className='title w-full pb-20'>Payment Details</div>
        </div>
        <div className='flex grid grid-cols-3 gap-4 pb-30 mb-30 border-b item-text'>
          <div className='font-bold'>Subtotal:</div>
          <div>{`${order.itemsCount ? order.itemsCount : 0} Items`}</div>
          <div className='text-right item-value'>${order.totalPrice}</div>

          { !isActiveOrder && (
          <>
            <div className='font-bold'>Shipping:</div>
            <div>{order.shippingTitle}</div>
            <div className='text-right item-value'>${order.totalShippingPrice}</div>

            <div className='font-bold'>Sales Tax:</div>
            <div className="empty-cell"></div>
            <div className='text-right item-value'>${order.totalTax}</div>
          </>)}

        </div>

        { !isActiveOrder && (
        <div className='flex justify-between mb-25 item-text item-value font-bold'>
          <div>Total:</div>
          <div className='text-lg'>{ moneyFormat(orderTotal) }</div>
        </div>
        )}

        <div className="flex w-full">
          <OrderCheckoutCTA 
            merchStore={merchStore} 
            combinedOrder={order} 
            display={isActiveOrder}
            disabled={!order.itemsCount}
          />
        </div>
        <div className='flex justify-center flex-col text-center mt-20'>
          <div className='item-text mb-10'>{isClosed ? 'This group order was processed on:' : 'This group order will process automatically on:'}</div>
          <div className='text-lg font-bold item-value'>{getLocalDateFullMonthText(closeDate)}</div>
        </div>
      </div>
    </div>
  )
}